import { gql } from '@apollo/client';

export const ButtonFragment = gql(`
    fragment ButtonFragment on Button {
        __typename
        sys {
            id
        }
        buttonText
        linkPath
        linkPage {
            ... on PageCaseStudy {
                __typename
                sys {
                    id
                }
                slug
            }
            ... on PageIndustry {
                __typename
                sys {
                    id
                }
                slug
            }
            ... on PageLanding {
                __typename
                sys {
                    id
                }
                slug
            }
            ... on PagePerson {
                __typename
                sys {
                    id
                }
                slug
            }
            ... on PageService {
                __typename
                 sys {
                    id
                }
                slug
            }
        }
    }
`);
